(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-countdown-assets"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cart-countdown')) {
    class CartCountdown extends HTMLElement {
      connectedCallback() {
        this.storageKey = this.dataset.storageKey;
        this.activeLabel = this.querySelector('.cart-countdown__active');
        this.endedLabel = this.querySelector('.cart-countdown__ended');
        this.timeLabel = this.querySelector('.cart-countdown__time');
        this.update = this.renderCountdown.bind(this);
        if (Number(this.dataset.items) === 0) {
          try { localStorage.removeItem(this.storageKey); } catch (_) {}
          this.hidden = true;
          return;
        }
        this.renderCountdown();
        this.interval = setInterval(this.update, 1000);
        window.addEventListener('storage', this.update);
        window.addEventListener('pageshow', this.update);
        document.addEventListener('visibilitychange', this.update);
      }
      disconnectedCallback() {
        clearInterval(this.interval);
        window.removeEventListener('storage', this.update);
        window.removeEventListener('pageshow', this.update);
        document.removeEventListener('visibilitychange', this.update);
      }
      renderCountdown() {
        if (!this.isConnected || Number(this.dataset.items) === 0) return;
        const now = Date.now();
        let deadline;
        try {
          const stored = localStorage.getItem(this.storageKey);
          deadline = Number(stored);
          if (!stored || !Number.isFinite(deadline) || deadline <= 0) {
            const drawer = this.closest('cart-drawer');
            if (drawer && getComputedStyle(drawer).visibility === 'hidden') return;
            deadline = now + Math.max(1, Math.min(60, Number(this.dataset.minutes) || 10)) * 60000;
            localStorage.setItem(this.storageKey, String(deadline));
          }
        } catch (_) {
          this.hidden = true;
          return;
        }
        const seconds = Math.max(0, Math.ceil((deadline - now) / 1000));
        const ended = seconds === 0;
        this.activeLabel.hidden = ended;
        this.endedLabel.hidden = !ended;
        if (!ended) {
          const text = `${Math.floor(seconds / 60).toString().padStart(2, '0')}:${(seconds % 60).toString().padStart(2, '0')}`;
          if (this.timeLabel.textContent !== text) this.timeLabel.textContent = text;
        }
        this.hidden = false;
      }
    }
    customElements.define('cart-countdown', CartCountdown);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mobile-cart-checkout"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('mobile-cart-checkout')) {
    customElements.define('mobile-cart-checkout', class extends HTMLElement {
      connectedCallback() {
        this.cart = this.closest('#main-cart');
        this.button = this.querySelector('button');
        if (!this.cart || !this.button) return;
        this.mobile = window.matchMedia('(max-width: 749px)');
        this.bar = document.createElement('div');
        this.bar.className = 'mobile-cart-checkout-bar';
        this.bar.hidden = true;
        this.placeButton = () => {
          if (this.mobile.matches) {
            if (!this.bar.isConnected) document.body.appendChild(this.bar);
            if (this.button.parentElement !== this.bar) this.bar.appendChild(this.button);
          } else {
            if (this.button.parentElement !== this) this.appendChild(this.button);
            this.bar.remove();
            document.documentElement.style.removeProperty('--mobile-cart-checkout-height');
          }
          this.sync();
        };
        this.sync = () => {
          const busy = !!this.cart.querySelector('.cart__items--disabled');
          const empty = this.cart.classList.contains('is-empty');
          this.bar.hidden = empty || !this.mobile.matches;
          if (this.button.disabled !== (busy || empty)) this.button.disabled = busy || empty;
          if (this.button.getAttribute('aria-busy') !== String(busy)) this.button.setAttribute('aria-busy', String(busy));
        };
        this.observer = new MutationObserver(this.sync);
        this.observer.observe(this.cart, { subtree: true, childList: true, attributes: true, attributeFilter: ['class'] });
        this.resizeObserver = new ResizeObserver(() => {
          if (this.mobile.matches && !this.bar.hidden) {
            document.documentElement.style.setProperty('--mobile-cart-checkout-height', `${Math.ceil(this.bar.getBoundingClientRect().height)}px`);
          }
        });
        this.resizeObserver.observe(this.bar);
        this.mobile.addEventListener('change', this.placeButton);
        this.placeButton();
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        this.resizeObserver?.disconnect();
        this.mobile?.removeEventListener('change', this.placeButton);
        if (this.button && this.button.parentElement === this.bar) this.appendChild(this.button);
        this.bar?.remove();
        document.documentElement.style.removeProperty('--mobile-cart-checkout-height');
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
